import { tw } from '@/utils/tw';

const Columns = tw.theme({
  base: `grid grid-cols-12 gap-2 container-inline empty:hidden [&>*:not(.grid-cols-12)]:col-span-full`,
});

export default Columns;
